import { createSelector } from 'reselect';

const getLocalConfigurator = (state) => state.configurator.localConfigurator;

export const getAvailableFamilyProductForConfigurator = createSelector(getLocalConfigurator, (configurator) => {
    return configurator.productFamilies ? configurator.productFamilies.slice().sort((a, b) => a.order - b.order).map(x => x.id) : []
}
);
